import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store';
import { logout } from 'store/slices/auth';

import { Icon } from '../icons';
import { Button } from '../button';

import { LogoutButtonProps } from './types';

export const LogoutButton = ({
  className,
  buttonClassName,
}: LogoutButtonProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['header']);

  return (
    <Button
      color="warning"
      className={className}
      buttonClassName={buttonClassName}
      onClick={() => dispatch(logout({ byUser: true }))}
      startIcon={<Icon.LogOut className="[&_path]:fill-current" />}
    >
      {t('logOut')}
    </Button>
  );
};
